// Astory Media - Minicart Fix
// Author: Zane Vondracek
// Date: 2025-10-19

document.addEventListener('DOMContentLoaded', () => {
  console.log('Astory Media Minicart Controller Active');

  const minicart = document.querySelector('.js-minicart');
  const body = document.body;

  if (!minicart) {
    console.warn('No minicart element found (.js-minicart missing)');
    return;
  }

  // Functions to open/close minicart
  const openMinicart = () => {
    minicart.classList.add('is-open');
    minicart.style.display = 'block';
    minicart.style.right = '0';
    minicart.style.zIndex = '9999';
    body.classList.add('minicart-open');
    console.log('Minicart opened');
  };

  const closeMinicart = () => {
    minicart.classList.remove('is-open');
    minicart.style.right = '-100%';
    body.classList.remove('minicart-open');
    console.log('Minicart closed');
  };

  // Attach listener to the correct cart icon
  const attachCartIconListeners = () => {
    const cartIcon = document.querySelector('.js-call-minicart');

    if (!cartIcon) {
      console.warn('Cart icon (.js-call-minicart) not found. Retrying in 2s...');
      setTimeout(attachCartIconListeners, 2000);
      return;
    }

    cartIcon.addEventListener('click', (e) => {
      e.preventDefault();
      if (minicart.classList.contains('is-open')) {
        closeMinicart();
      } else {
        openMinicart();
      }
    });

    console.log('Minicart toggle bound to .js-call-minicart');
  };

  attachCartIconListeners();

  // Optional close button inside minicart
  const closeBtn = minicart.querySelector('.js-minicart-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', closeMinicart);
  }

  // Quantity buttons
  const attachQuantityListeners = () => {
    const qtyButtons = minicart.querySelectorAll('.quantity__button, .js-qty-btn');
    qtyButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const input = btn.parentElement.querySelector('input[name="quantity"], input[name="updates[]"]');
        if (!input) return;

        let current = parseInt(input.value);
        if (btn.classList.contains('plus')) current++;
        if (btn.classList.contains('minus')) current = Math.max(1, current - 1);
        input.value = current;

        const line = input.dataset.line || input.closest('[data-line-item]')?.dataset.line;
        if (line) updateCartQuantity(line, current);
      });
    });
  };

  // Shopify AJAX cart update
  const updateCartQuantity = (line, quantity) => {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity }),
    })
      .then(res => res.json())
      .then(cart => {
        console.log(`Quantity updated (line ${line} → ${quantity})`);
        refreshMinicart(cart);
      })
      .catch(err => console.error('Error updating cart:', err));
  };

  // Refresh minicart after update
  const refreshMinicart = (cart) => {
    fetch('/?section_id=cart-drawer')
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const newContent = parser.parseFromString(html, 'text/html').querySelector('.js-minicart');
        if (newContent) {
          minicart.innerHTML = newContent.innerHTML;
          attachQuantityListeners();
          console.log('Minicart refreshed');
        }
      })
      .catch(err => console.error('Error refreshing minicart:', err));
  };

  // Initialise
  attachQuantityListeners();
  console.log('Minicart fix script loaded');
});
